import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, option_type, class_type, int32_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";

export class UpdateConsumptionFee extends Record {
    constructor(Description, Volume, ChargePerUnit, ChargeUnit, UnitOfMeasure, VatRatePercent, PeriodFrom, PeriodTo, AccountNo) {
        super();
        this.Description = Description;
        this.Volume = (Volume | 0);
        this.ChargePerUnit = ChargePerUnit;
        this.ChargeUnit = (ChargeUnit | 0);
        this.UnitOfMeasure = UnitOfMeasure;
        this.VatRatePercent = VatRatePercent;
        this.PeriodFrom = PeriodFrom;
        this.PeriodTo = PeriodTo;
        this.AccountNo = (AccountNo | 0);
    }
}

export function UpdateConsumptionFee$reflection() {
    return record_type("Containers.ConsumptionFees.Model.UpdateConsumptionFee", [], UpdateConsumptionFee, () => [["Description", string_type], ["Volume", int32_type], ["ChargePerUnit", class_type("System.Decimal")], ["ChargeUnit", int32_type], ["UnitOfMeasure", string_type], ["VatRatePercent", class_type("System.Decimal")], ["PeriodFrom", option_type(class_type("System.DateOnly"))], ["PeriodTo", option_type(class_type("System.DateOnly"))], ["AccountNo", int32_type]]);
}

export class ConsumptionFee extends Record {
    constructor(ConsumptionFeeNr, Description, Volume, ChargePerUnit, ChargeUnit, UnitOfMeasure, VatRatePercent, InvoiceNr, PeriodFrom, PeriodTo, AccountNo, FeeExclVat, FeeInclVat) {
        super();
        this.ConsumptionFeeNr = (ConsumptionFeeNr | 0);
        this.Description = Description;
        this.Volume = Volume;
        this.ChargePerUnit = ChargePerUnit;
        this.ChargeUnit = ChargeUnit;
        this.UnitOfMeasure = UnitOfMeasure;
        this.VatRatePercent = VatRatePercent;
        this.InvoiceNr = InvoiceNr;
        this.PeriodFrom = PeriodFrom;
        this.PeriodTo = PeriodTo;
        this.AccountNo = (AccountNo | 0);
        this.FeeExclVat = FeeExclVat;
        this.FeeInclVat = FeeInclVat;
    }
}

export function ConsumptionFee$reflection() {
    return record_type("Containers.ConsumptionFees.Model.ConsumptionFee", [], ConsumptionFee, () => [["ConsumptionFeeNr", int32_type], ["Description", string_type], ["Volume", class_type("System.Decimal")], ["ChargePerUnit", class_type("System.Decimal")], ["ChargeUnit", class_type("System.Decimal")], ["UnitOfMeasure", string_type], ["VatRatePercent", class_type("System.Decimal")], ["InvoiceNr", option_type(int32_type)], ["PeriodFrom", option_type(class_type("System.DateOnly"))], ["PeriodTo", option_type(class_type("System.DateOnly"))], ["AccountNo", int32_type], ["FeeExclVat", class_type("System.Decimal")], ["FeeInclVat", class_type("System.Decimal")]]);
}

